module.exports = __webpack_public_path__ + "static/adaptable-b1101476fa1d0466546480a9c7689689.png";